import React from 'react';
import { Box, Flex } from 'rebass/styled-components';
import { Formik, Form, FastField } from 'formik';
import * as Yup from 'yup';
import { Button, FormInput } from '@getro/rombo';
import PropTypes from 'prop-types';

export const CreateListInput = ({ title, onSubmit, createButtonLabel, name, term, isLoading }) => (
  <Flex bg="neutral.0" sx={{ flexDirection: 'column', gap: '24px' }}>
    <Box as="h4" fontSize="14px" fontWeight="500" lineHeight="1.4">
      {title}
    </Box>
    <Formik
      initialValues={{ term }}
      onSubmit={(values) => onSubmit(values.term)}
      validationSchema={Yup.object().shape({
        term: Yup.string().required(`A ${name} name is required.`),
      })}
      validateOnBlur
    >
      <Box as={Form} sx={{ flexDirection: 'column', gap: '8px', display: 'flex' }}>
        <FastField sx={{ height: '32px' }} size="small" label={`New ${name} name`} component={FormInput} name="term" />
        <Button size="small" loading={isLoading} justifyContent="center" type="submit">
          {createButtonLabel}
        </Button>
      </Box>
    </Formik>
  </Flex>
);

CreateListInput.propTypes = {
  title: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  createButtonLabel: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  term: PropTypes.string,
  isLoading: PropTypes.bool,
};

CreateListInput.defaultProps = {
  term: '',
  isLoading: false,
};
